import { render, staticRenderFns } from "./menu-scale-modal.vue?vue&type=template&id=022eaa19&scoped=true&"
import script from "./menu-scale-modal.vue?vue&type=script&lang=js&"
export * from "./menu-scale-modal.vue?vue&type=script&lang=js&"
import style0 from "./menu-scale-modal.vue?vue&type=style&index=0&id=022eaa19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022eaa19",
  null
  
)

export default component.exports